import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

function FAQ() {
  const [faqs, setFaqs] = useState([
    {
      question: "How do I open an account?",
      answer:
        "You can open an account by visiting our office in Salem, Tamil Nadu, or by contacting us through phone or email. Our representatives will guide you through the process and inform you about the required documents, such as Aadhaar card, PAN card, and photographs.",
      isOpen: false,
    },
    {
      question: "What are the benefits of using AEPS?",
      answer:
        "AEPS (Aadhaar Enabled Payment System) allows you to perform basic banking transactions like cash withdrawals, deposits, and balance inquiries using your Aadhaar number and biometric authentication. It's convenient, secure, and accessible, especially in areas with limited ATM access.",
      isOpen: false,
    },
    {
      question: "What types of loans do you offer?",
      answer:
        "We offer Gold Loans, Personal Loans, and Business Loans. Each loan type has specific eligibility criteria and terms. You can find more details on our website or by contacting us directly.",
      isOpen: false,
    },
    {
      question: "How can I apply for a loan?",
      answer:
        "You can apply for a loan by visiting our office or contacting us to schedule an appointment. Our loan officers will guide you through the application process and explain the required documentation, such as income proof, address proof, and identity proof.",
      isOpen: false,
    },
    {
      question: "How secure is AEPS?",
      answer:
        "AEPS is considered a secure system as it relies on biometric authentication (fingerprint or iris scan), which is unique to each individual. However, it's important to follow best practices to protect your Aadhaar information and never share your biometric data with anyone.",
      isOpen: false,
    },
    {
      question: "What are the benefits of taking a Gold Loan?",
      answer:
        "Gold Loans offer quick access to funds with minimal documentation. They can be a good option for short-term financial needs. The gold is securely stored and returned upon loan repayment.",
      isOpen: false,
    },
    {
      question: "What is the eligibility criteria for a Personal Loan?",
      answer:
        "Eligibility criteria for Personal Loans typically include factors like age (usually between 21 and 60 years), minimum monthly income, credit score (700+ is preferred), and employment stability (at least 1 year of work experience).",
      isOpen: false,
    },
  ]);

  const toggleFAQ = (index) => {
    setFaqs(
      faqs.map((faq, i) => {
        if (i === index) {
          return { ...faq, isOpen: !faq.isOpen };
        } else {
          return { ...faq, isOpen: false }; // Close other FAQs
        }
      })
    );
  };

  return (
    <section id="faq" className="py-16 px-6 bg-gray-100">
      <div className="container mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8 text-center">
          Frequently Asked Questions
        </h2>
        <div className="max-w-5xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              className="bg-white p-5 md:p-6 rounded-lg shadow-md border border-gray-200 overflow-hidden"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <button
                type="button"
                className="w-full text-left font-medium text-gray-800 text-lg md:text-xl flex justify-between items-center focus:outline-none"
                onClick={() => toggleFAQ(index)}
              >
                <span>{faq.question}</span>
                <motion.span
                  initial={{ rotate: 0 }}
                  animate={{ rotate: faq.isOpen ? 180 : 0 }}
                  transition={{ duration: 0.2 }}
                  className="flex-shrink-0 ml-4"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </motion.span>
              </button>
              <AnimatePresence initial={false}>
                {faq.isOpen && (
                  <motion.div
                    key="content"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                    className="overflow-hidden"
                  >
                    <p className="mt-4 text-gray-600 text-base md:text-lg pr-4">
                      {faq.answer}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQ;